export default "__VITE_ASSET__BmKTdxuZ__"